
export default {
  props: {
    category: {
      type: String,
      default: null
    }
  },
  vessel: {
    tabs: {
      backgroundColor: 'white',
      zIndex: 20,
      overflow: 'hidden'
    },
    tab: {
      fontWeight: 'normal',
      padding: 'sm',
      cursor: 'pointer',
      whiteSpace: 'no-wrap',
      fontSize: 'sm',
      borderBottomWidth: 2,
      borderColor: 'transparent'
    },
    activeTab: {
      borderColor: 'red'
    }
  },
  async fetch() {
    const { $content, $i18n: { locale } } = this
    const category = await $content(locale, 'menus', this.category)
      .only(['children'])
      .fetch()

    this.items = category.children || []
  },
  watch: {
    category: {
      immediate: true,
      handler(newValue, oldValue) {
        if (newValue && newValue != oldValue) {
          this.$fetch()
        }
      }
    }
  },
  data() {
    return {
      items: []
    }
  },
  computed: {
    tabsStyle() {
      return {
        'box-shadow': 'inset 0 -1px 0 #e1e1e1',
        height: '3.5rem'
      }
    },
    offset() {
      return 150
    },
    activeClass() {
      return Object.keys(this.$vessels.activeTab).join(' ')
    },
    stickyOffset() {
      return this.$screen.lg ? 77 : 68
    }
  },
  methods: {
    onChange(current) {
      const parent = this.$refs.parent.$el
      if (!current || !parent) return

      const margin = ((parent.clientWidth - current.scrollWidth) / 2)

      parent.scrollLeft = current.offsetLeft - margin
    },
    categoryId(category) {
      return category.id || category.name.replace(/^\s+|\s+$/g, '')
        .toLowerCase()
        .replace(/[^a-z0-9 -]/g, '')
        .replace(/\s+/g, '-')
        .replace(/-+/g, '-')
    }
  }
}
